export const alertConstants = {
    SET_ALERTS: 'POLICY_SET_ALERTS',
};
